import { gql } from "@apollo/client";

export const GET_CHECK_BASED_EVIDENCES = gql`
  query getCheckBasedEvidences(
    $page: Int
    $pageSize: Int
    $checkCategory: String
    $controlDomain: String
    $showFullyReviewed: Boolean
    $search: String
  ) {
    getCheckBasedEvidences(
      page: $page
      pageSize: $pageSize
      checkCategory: $checkCategory
      controlDomain: $controlDomain
      showFullyReviewed: $showFullyReviewed
      search: $search
    ) {
      totalCount
      stats {
        awaitingReview
        fullyApproved
        partiallyDone
        totalLinkableChecks
      }
      checks {
        checkId
        checkName
        checkCategory
        checkDescription
        pendingCount
        approvedCount
        rejectedCount
        totalEntities
        peExists
        mappedControls {
          id
          name
          domain
        }
      }
    }
  }
`;

export const GET_AI_EVIDENCE_SUMMARY = gql`
  query getAIEvidenceSummary($frameworkId: Int) {
    getAIEvidenceSummary(frameworkId: $frameworkId) {
      pendingCount
      approvedCount
      rejectedCount
      totalCount
      approvedPercent
      checksCount
      connectedIntegrations
      byCheck {
        checkId
        pendingCount
        approvedCount
        myPendingCount
      }
      byControl {
        controlId
        pendingCount
        approvedCount
        myPendingCount
      }
      ineligibleControlIds
    }
  }
`;

export const GET_AI_EVIDENCE_OWNERS_FOR_CHECK = gql`
  query getAIEvidenceOwnersForCheck($checkId: Int) {
    getAIEvidenceOwnersForCheck(checkId: $checkId) {
      employeeDataId
      email
      name
      integrations
      pendingCount
    }
  }
`;

export const GET_EVIDENCES_BY_CHECK = gql`
  query getEvidencesByCheck($checkId: Int!, $page: Int, $pageSize: Int) {
    getEvidencesByCheck(checkId: $checkId, page: $page, pageSize: $pageSize) {
      totalCount
      entities {
        validationId
        entityId
        entityType
        entityName
        approvalStatus
        reviewedBy
        reviewedAt
        reason
      }
    }
  }
`;

export const GET_ENTITY_CONTENT = gql`
  query getEntityContent($entityId: String!, $entityType: String!) {
    getEntityContent(entityId: $entityId, entityType: $entityType) {
      entityId
      entityType
      name
      description
      formattedContent
      metadata
      attachments {
        id
        name
        type
        downloadUrl
      }
      checks {
        validationId
        checkId
        checkName
        checkCategory
        checkDescription
        isValid
        approvalStatus
        reviewedBy
        reviewedAt
        reason
      }
    }
  }
`;

export const REQUEST_AI_EVIDENCE_ACCESS = gql`
  mutation requestAIEvidenceAccess($checkId: Int, $ownerIds: [String]) {
    requestAIEvidenceAccess(checkId: $checkId, ownerIds: $ownerIds) {
      success
      message
      notifiedCount
    }
  }
`;

export const REQUEST_AI_EVIDENCE_REVIEW = gql`
  mutation requestAIEvidenceReview($checkId: Int, $ownerIds: [String]) {
    requestAIEvidenceReview(checkId: $checkId, ownerIds: $ownerIds) {
      success
      message
      notifiedCount
    }
  }
`;

export const APPROVE_INTEGRATED_EVIDENCE = gql`
  mutation approveIntegratedEvidence($validationId: Int!) {
    approveIntegratedEvidence(validationId: $validationId) {
      success
      message
      validationId
      approvalStatus
    }
  }
`;

export const REJECT_INTEGRATED_EVIDENCE = gql`
  mutation rejectIntegratedEvidence($validationId: Int!) {
    rejectIntegratedEvidence(validationId: $validationId) {
      success
      message
      validationId
      approvalStatus
    }
  }
`;

export const BULK_APPROVE_INTEGRATED_EVIDENCE = gql`
  mutation bulkApproveIntegratedEvidence(
    $entityId: String!
    $entityType: String!
  ) {
    bulkApproveIntegratedEvidence(
      entityId: $entityId
      entityType: $entityType
    ) {
      success
      message
      updatedCount
    }
  }
`;
